/** scroll the parent element to the giving element. */
export const scrollParentToElement = (parentElement: HTMLElement, el: HTMLElement, offset: number) => {
  if (!el || isElementVisible(parentElement, el, offset)) return;

  const itemTop = el.offsetTop - offset;
  const itemBottom = itemTop + el.clientHeight;
  const containerTop = parentElement.scrollTop + offset;
  const containerBottom = containerTop + parentElement.clientHeight;

  if (itemTop < containerTop) {
    parentElement.scrollTop = itemTop;
  } else if (itemBottom > containerBottom) {
    parentElement.scrollTop = itemBottom - parentElement.clientHeight;
  }
}

const isElementVisible = (parentElement: HTMLElement, item: HTMLElement, offset: number): boolean => {
  const itemTop = item.offsetTop - offset;
  const itemBottom = itemTop + item.clientHeight;
  const containerTop = parentElement.scrollTop + offset;
  const containerBottom = containerTop + parentElement.clientHeight;

  return itemTop >= containerTop && itemBottom <= containerBottom;
}